import { Action } from '@ngrx/store';
import { IrisThemeI } from '@iris/common/models/IrisTheme';

export enum IrisThemeActionsTypes {
  SetTheme = '[Theme] Set theme',
  InitThemeComplete = '[Theme] Init Theme Complete',
  UpdateDarkMode = '[Theme] Update Dark Mode',
  UpdateStrabagControls = '[Theme] Update Strabag Controls',
  UpdateStrabagColors = '[Theme] Update Strabag Colors',
}

export class SetTheme implements Action {
  readonly type = IrisThemeActionsTypes.SetTheme;
  constructor(public payload: IrisThemeI) {}
}

export class InitThemeComplete implements Action {
  readonly type = IrisThemeActionsTypes.InitThemeComplete;
  constructor(public payload: IrisThemeI) {}
}

export class UpdateDarkMode implements Action {
  readonly type = IrisThemeActionsTypes.UpdateDarkMode;
  constructor(public payload: boolean) {}
}

export class UpdateStrabagControls implements Action {
  readonly type = IrisThemeActionsTypes.UpdateStrabagControls;
  constructor(public payload: boolean) {}
}

export class UpdateStrabagColors implements Action {
  readonly type = IrisThemeActionsTypes.UpdateStrabagColors;
  constructor(public payload: boolean) {}
}

export type IrisThemeActions =
  | SetTheme
  | InitThemeComplete
  | UpdateDarkMode
  | UpdateStrabagControls
  | UpdateStrabagColors;
